import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Organization Data Module Service Stores
 * Updated to match backend api-types
 *
 * Note: No organization-data specific api-types exist yet.
 */
export const organizationDataStores: ServiceStoreConfig[] = [
  // No organization-data specific api-types exist yet
];
